import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

export const useTranslation = () => {
  const { language, changeLanguage } = useLanguage();
  
  const t = (key) => getTranslation(language, key);
  
  return {
    t,
    language,
    changeLanguage,
  };
};

